import BFFAPI from './utils/BFFAPI';

class AssetTagsAPI extends BFFAPI {
  createTag = (tagCategoryId: string, name: string) => {
    const req = this.fetchHelper.createPostRequest(`${this.endpoint}`, {
      tagCategoryId,
      name,
    });
    return this.fetch(req);
  };

  updateTag = (tagId: string, name: string) => {
    const req = this.fetchHelper.createPatchRequest(
      `${this.endpoint}/${tagId}`,
      {
        name,
      }
    );
    return this.fetch(req);
  };

  deleteTag = (tagId: string) => {
    const req = this.fetchHelper.createDeleteRequest(
      `${this.endpoint}/${tagId}`
    );
    return this.fetch(req);
  };

  addAssetTagRelationships = (tagId: string, assetIds: AssetId[]) => {
    const req = this.fetchHelper.createPostRequest(
      `${this.endpoint}/${tagId}/asset-relationship`,
      assetIds
    );
    return this.fetch(req);
  };

  removeAssetTagRelationships = (tagId: string, assetIds: AssetId[]) => {
    const req = this.fetchHelper.createDeleteRequest(
      `${this.endpoint}/${tagId}/asset-relationship`,
      assetIds
    );
    return this.fetch(req);
  };
}

export default new AssetTagsAPI('/fleet/secure/tags');
